module.exports = __webpack_public_path__ + "img/magento-code-review.8ec9bd32.jpeg";